import { CurrencyModel } from '@/features/currencies/types/models/currency.model'
import { safeParseFloat } from './parse-float'

export const formatPrice = (
  price: string | number | undefined,
  currency?: CurrencyModel | null,
) => {
  if (price === undefined) {
    return `0 ${currency?.symbol || '$'}`
  }
  const calculatedPrice = safeParseFloat(price.toString())
  const floatPrice = safeParseFloat(calculatedPrice.toFixed(2))

  if (floatPrice % 1 !== 0) {
    return `${floatPrice.toFixed(2)} ${currency?.symbol || '$'}`
  }
  return `${floatPrice} ${currency?.symbol || '$'}`
}
